import type { GridHint } from "../../shared/types";

export interface ClueProbeState {
  key: string;
  stage: 1 | 2;
}

// Clicking the first square of a word probes its clue. When a square starts
// both an across and a down word, clicks cycle: across first, then down,
// then back to across.
export function probeClueForCell(
  clues: GridHint[],
  x: number,
  y: number,
  prev: ClueProbeState | null
): { clueId: string; state: ClueProbeState } | null {
  const across = clues.find((c) => c.direction === "across" && c.startX === x && c.startY === y);
  const down = clues.find((c) => c.direction === "down" && c.startX === x && c.startY === y);
  if (!across && !down) return null;

  const key = `${x},${y}`;
  if (prev && prev.key === key && across && down && prev.stage === 1) {
    return { clueId: `down-${down.number}`, state: { key, stage: 2 } };
  }
  const first = across ?? down!;
  return { clueId: `${first.direction}-${first.number}`, state: { key, stage: 1 } };
}